 /*
 * Actions types
 */

import {
  SET_PRODUCT_INFORMATIONS,
  SET_CURRENT_PRODUCT,
  SET_OPEN_PRODUCT
} from './types/actionsTypes'

/*
* Mutations types
*/

import {
  UPDATE_PRODUCT_INFORMATIONS,
  UPDATE_CURRENT_PRODUCT,
  UPDATE_OPEN_PRODUCT
} from './types/mutationsTypes'

/**
*
* Actions ProductFile Orange
*
*/

const actions = {
  [SET_PRODUCT_INFORMATIONS]: ({ commit }, productInformations) => {
    commit(UPDATE_PRODUCT_INFORMATIONS, productInformations)
  },
  [SET_CURRENT_PRODUCT]: ({ commit }, {currentProduct: currentProduct}) => {
    commit(UPDATE_CURRENT_PRODUCT, currentProduct)
  },
  [SET_OPEN_PRODUCT]: ({ commit }, {openProduct: openProduct}) => {
    commit(UPDATE_OPEN_PRODUCT, openProduct)
  }
}

export default actions